import { Button, Tooltip, Typography, useTheme } from "@mui/material"
import {useTranslation} from 'react-i18next'

const ButtonBase = ({onClick, sx = {}, active, children}) => {
  return (
    <Button
      disableRipple
      variant="outlined"
      sx={{
        borderRadius: '8px',
        color: active ? 'primary.main': 'inherit',
        borderColor: active ? 'primary.main' : 'border.primary',
        height: '40px',
        ...sx
      }}
      onClick={onClick}
    >
      {
        children
      }
    </Button>
  )
}

export const ButtonSites = ({
  active = false,
  onClick,
  count
}) => {
  const {t} = useTranslation()
  return (
    <ButtonBase onClick={onClick} active={active}>
      <i
        className={`fa-light fa-bars-filter`}
        style={{ fontSize: "16px" }}
      ></i>
      <Typography variant="caption" ml={1}>
        {
          t('ui_elements.count_selected_sites', {count})
        }
      </Typography>
    </ButtonBase>
  )
}

const ButtonUnfold = ({
  isUnfolded,
  onClick,
  sx = {}
}) => {
  const { t } = useTranslation()
  const theme = useTheme()
  
  return (
    <Tooltip
      title={t(`actions.${isUnfolded ? "close_all" : 'open_all'}`)}
    >
      <i
        className={`fa-light ${
          isUnfolded ? 'fa-arrows-to-line' : 'fa-arrows-from-line'
        }`}
        style={{ 
          fontSize: '16px', 
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: theme.spacing(1),
          border: `1px solid ${theme.palette.grey[100]}`,
          padding: '8px'
        }}
        onClick={onClick}
      ></i>
    </Tooltip>
  )
}


export default ButtonUnfold
